<template>
    <v-expand-transition>
        <div v-if="!readOnly && hasSuggestion">
            <div class="suggestion-container mb-5">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px;">Différence détectée</b>
                    </div>
                </div>

                <div class="mt-3">
                    Un nouveau lien de la page {{ currentCommunications[0].type.label }} a été détecté :
                    <b>{{ getSuggestionByTypeName().value }}</b>

                    <a class="ml-2" :href="getSuggestionByTypeName().value" target="_blank">
                        <v-icon :color="primaryColor">open_in_new</v-icon>
                    </a>
                </div>

                <div class="d-flex justify-content-center flex-wrap mt-4 mb-2" v-if="!readOnly">
                    <v-btn class="text-none mr-5"
                           color="warning"
                           large
                           style="border-radius: 25px; border-width: 2px; font-weight: bold"
                           outlined
                           @click="addSuggestion()">
                                <span v-if="currentCommunications.length &&
                                            (currentCommunications[0].value === null ||
                                            currentCommunications[0].value === '')">Ajouter </span>
                        <span v-else>Modifier</span>
                        <span class="ml-1">le lien {{ currentCommunications[0].type.label }}</span>
                    </v-btn>

                    <v-btn class="text-none ml-5"
                           text
                           color="#ffa533"
                           style="font-size: 16px"
                           @click="removeSuggestion()">
                        Ignorer
                    </v-btn>
                </div>
            </div>
        </div>
    </v-expand-transition>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"

export default {
    name: "PlatformSuggestion",
    props: ["field"],
    computed: {
        ...mapState("web_form", [
            "provider",
            "suggestedCommunications",
            "readOnly",
        ]),
        ...mapGetters("web_form", ["getCodeFromField"]),
        ...mapState("webFormStyle", ["primaryColor"]),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        hasSuggestion() {
            return this.suggestedCommunications.find(suggestion => suggestion.type.name === this.fieldCode) !== undefined
        },
        suggestion() {
            return this.suggestedCommunications.find(suggestion => suggestion.type.name === this.fieldCode)
        },
        currentCommunications() {
            return this.provider.communications.filter(com => com.type.name === this.fieldCode)
        },
    },
    methods: {
        ...mapMutations("web_form", ["pushSuggestedCommunications"]),
        getSuggestionByTypeName() {
            let exist = this.suggestedCommunications.find(com => com.type.name === this.fieldCode)

            return exist !== undefined ? exist : null
        },
        removeSuggestion() {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if (suggestion.type.name === this.fieldCode) {
                    this.suggestedCommunications.splice(index, 1)
                }
            })
        },
        addSuggestion() {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if (suggestion.type.name === this.fieldCode) {
                    this.provider.communications.forEach(com => {
                        if (com.type.name === suggestion.type.name) {
                            com.value = suggestion.value
                        }
                    })
                }
            })

            this.removeSuggestion()
        },
    },
}
</script>

